/*=====================================
    NewsViewSideBar

    Author: Ac
    CreateTime: 2018 / 10 / 12
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
// import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GlobalStyle } from 'stylecomponents';
// import CupoyRouter from 'components/commons/router/CupoyRouter';
// import CupoySrefView from 'components/commons/router/CupoySrefView';
import Tile from 'components/commons/Tile';
import GLOBAL from 'nonnglobal';

/**
|--------------------------------------------------
| Variables
|--------------------------------------------------
*/
const tileStyle = {
    tileWidth: 212,
    imgWidth: 212,
    imgHeight: 122,
    fontSize: 13,
    type: 'sideBlock',
};
/*--------------------------
    Styled
--------------------------*/
const Container = GlobalStyle.BasicBlock.extend`
`;
const Topbar = styled.div`
    height: 50px;
    padding: 14px 16px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 1px #D9D9D9;
`;

const Title = styled.div`
    font-size: 20px;
    font-weight: bold;
`;
/*--------------------------
    Main Component
--------------------------*/
class NewsViewSideBar extends Component {

    // static propTypes = {
    // };

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
        this.fetchListProfitEvents();
    }

    fetchListProfitEvents = () => {
        this.props.profitEventActions.listProfitEvents();
    }

    toProfitEvent = ({ eventid, clickurl } = {}) => {
        this.props.profitEventActions.logProfitEventClick({
            eventid,
        });
        window.location.assign(clickurl);
    }

    render() {

        const {
            profitEventMap,
            profitEventIds = [],
        } = this.props;

        if(profitEventIds.length === 0) return null;

        const _profitEventIds = profitEventIds.slice(0, 4);

        return (
            <div>
                <Container>
                    <Topbar>
                        <Title>好康活動</Title>
                    </Topbar>
                    {_profitEventIds.map(eventId => {

                        const profitEvent = profitEventMap[eventId];

                        const {
                            title = '',
                            eventimg,
                        } = profitEvent;

                        return (
                            <Tile
                                key={eventId}
                                tileStyle={tileStyle}
                                clickCallback={this.toProfitEvent}
                                callbackParams={profitEvent}
                                text={title.trim()} 
                                img={GLOBAL.imgSrcRootURL + `/profiteventimgs/${eventId}/${eventimg}`}
                            />
                        );
                    })}
                </Container>
            </div>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        profitEventMap: state.profitevent.itemMap,
        profitEventIds: state.profitevent.ids,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        profitEventActions: bindActionCreators(actionCreators.profitEventActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(NewsViewSideBar);